import { useNavigate } from 'react-router';
import { Check, Cloud, CloudOff, RefreshCw, TriangleAlert } from 'lucide-react';
import { cn } from '@dd/ui';
import { useSync } from '@/sync/status';
import { useT, intFmt } from '@/lib/i18n';
import { syncNow } from '@/sync/engine';

/** Top-bar sync icon: ✓ synced · spinner syncing · cloud+count waiting · crossed cloud offline · red triangle = something needs attention (Bible 13.x). */
export function SyncIndicator() {
  const s = useSync();
  const nav = useNavigate();
  const { t } = useT();
  const problem = s.failed + s.rejected > 0 || (s.lastError && s.lastError !== 'network' && s.online);
  let icon = <Check size={18} />;
  let tone = 'text-ok';
  let label = t('সব সেভ হয়েছে', 'All synced');
  if (!s.online) { icon = <CloudOff size={18} />; tone = 'text-warn'; label = t('অফলাইন', 'Offline'); }
  else if (problem) { icon = <TriangleAlert size={18} />; tone = 'text-bad'; label = t('সিঙ্ক সমস্যা', 'Sync problem'); }
  else if (s.syncing) { icon = <RefreshCw size={18} className="animate-[dd-spin_1s_linear_infinite]" />; tone = 'text-brand'; label = t('সিঙ্ক হচ্ছে…', 'Syncing…'); }
  else if (s.pending > 0) { icon = <Cloud size={18} />; tone = 'text-brand'; label = t(`${intFmt(s.pending)}টি অপেক্ষায়`, `${s.pending} waiting`); }
  return (
    <button type="button" aria-label={label} title={label} onClick={() => (problem || s.quarantined ? nav('/sync-problems') : void syncNow())} className={cn('relative flex h-10 w-10 items-center justify-center rounded-full hover:bg-neutral-100', tone)}>
      {icon}
      {s.pending > 0 && !problem && s.online && <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand px-1 text-[10px] font-bold text-white">{s.pending > 99 ? '99+' : s.pending}</span>}
    </button>
  );
}
